/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUserRequestsUploadDocumentMutationRequest,
  PostUserRequestsUploadDocumentMutationResponse,
  PostUserRequestsUploadDocument400,
} from '../entities/PostUserRequestsUploadDocument'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUserRequestsUploadDocumentUrl() {
  return `/user-requests/upload-document` as const
}

/**
 * @description Загрузка документа
 * @summary Загрузка документа
 * {@link /user-requests/upload-document}
 */
export async function postUserRequestsUploadDocument(
  data: PostUserRequestsUploadDocumentMutationRequest,
  config: Partial<RequestConfig<PostUserRequestsUploadDocumentMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const formData = new FormData()
  if (data) {
    Object.keys(data).forEach((key) => {
      const value = data[key as keyof typeof data]
      if (typeof key === 'string' && (typeof value === 'string' || (value as Blob) instanceof Blob)) {
        formData.append(key, value as unknown as string)
      }
    })
  }
  const res = await request<
    PostUserRequestsUploadDocumentMutationResponse,
    ResponseErrorConfig<PostUserRequestsUploadDocument400>,
    PostUserRequestsUploadDocumentMutationRequest
  >({
    method: 'POST',
    url: getPostUserRequestsUploadDocumentUrl().toString(),
    data: formData,
    ...requestConfig,
    headers: { 'Content-Type': 'multipart/form-data', ...requestConfig.headers },
  })
  return res.data
}